export const base_path = "";
export const LoginDealerId = 101